app.bind('default inputShadow inputs basic', function(context){
    $('[js-inputShadow]', context).inputShadow();
});

app.bind('default inputmask inputs basic', function(context){
    $('[js-input-phone]', context).attr('data-is-inputmask', true).inputmask({
        mask: '+7 (999) 999-99-99',
        placeholder: '+7 (___) ___-__-__',
        // jitMasking: 4,
        clearMaskOnLostFocus: false,
        showMaskOnHover: true,
        showMaskOnFocus: true,
        isComplete: function (buffer, opts) {
            return Inputmask.isValid(buffer.join(''), {mask: opts.mask})
        },
        oncomplete: function () {
            $(this).trigger('maskComplete');
        },
        onincomplete: function () {
            $(this).trigger('maskIncomplete');
        }
    });

    $('[js-input-time]', context).attr('data-is-inputmask', true).inputmask({
        mask: "h:s - h:s",
        placeholder: "hh:mm - hh:mm",
        alias: "datetime",
    });

    $('[js-input-number]', context).attr('data-is-inputmask', true).each((inputIndex, input) => {
        const $input = $(input);
        let { minValue, maxValue } = getMinMax($input);
        let value = parseInt($input.val().replace(/[^0-9.]/g, ''));

        $input.off('.input-number').on({
            'input.input-number': (e) => {
                setValue();
            },
        }).inputmask('numeric', {
            radixPoint: ",",
            groupSeparator: ' ',
            digits: 2,
            autoGroup: true,
            rightAlign: false,
        });
        // .inputmask({
        //     mask: '9{*}|[ ]',
        //     repeat: maxValue.length,
        //     greedy: true,
        //     regex: '[0-9]*',
        //     skipOptionalPartCharacter: ' ',
        //     showMaskOnHover: false,
        //     showMaskOnFocus: false,
        //     isComplete: function (buffer, opts) {
        //         return Inputmask.isValid(buffer.join(''), {regex: opts.regex});
        //     },
        //     onBeforeWrite: function (event, buffer, caretPos, opts) {
        //         console.log(this)
        //         const _was = buffer.join('').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        //         buffer = _was.split();
        //     },
        // });

        function setValue (val = parseInt($input.val().replace(/[^0-9.]/g, ''))) {
            if ( val < minValue ) {
                value = minValue;
                $input.val(value).trigger('change');
            }
            else if ( val > maxValue ) {
                value = maxValue;
                $input.val(value).trigger('change');
            }
            else {
                value = val;
            }

            return value;
        }

        function getMinMax($input) {
            let minValue = typeof $input.data('min') !== 'undefined' ? parseInt($input.data('min')) : $input.prop('min').length > 0 ? $input.prop('min') : 1;
            let maxValue = typeof $input.data('max') !== 'undefined' ? parseInt($input.data('max')) : $input.prop('max').length > 0 ? $input.prop('max') : 999999999;

            return { minValue, maxValue };
        }
    });


    $('[data-inputmask]', context).attr('data-is-inputmask', true).inputmask({
        oncomplete: function () {
            $(this).trigger('maskComplete');
        },
        onincomplete: function () {
            $(this).trigger('maskIncomplete');
        }
    });
});

app.bind('default input-set inputs basic', function(context) {
    const $inputSets = $('[js-input-set]', context);

    $inputSets.each((inputSetIndex, inputSet) => {
        const $inputSet = $(inputSet);
        const $inputItem = $inputSet.find('[js-input-set-item]');
        const $input = $inputItem.find('input');

        $inputItem.off('.input-set').on('change.input-set changeSilent.input-set', () => {
            if($input.prop('checked')) {
                $inputSet.addClass('is-checked');
            }
            else {
                $inputSet.removeClass('is-checked');
            }
        });

        $inputSet.off('.input-set').on('click.input-set', () => {
            if(!$input.prop('checked')) {
                $input.prop('checked', true).trigger('change');
            }
            else if($input.prop('checked') && $input.is(':checkbox')) {
                $input.prop('checked', false).trigger('change');
            }
        });

    });
});

app.bind('default selo inputs basic', function(context){
    const $bodyWrapper = $('.body__wrapper');
    const tipOptions = {
        position: {
            viewport: $bodyWrapper,
            effect: false,
            my: 'top left',
            at: 'bottom left',
            adjust: {
                scroll: false,
                method: 'shift flipinvert',
                x: 0,
                y: -1
            }
        },
        show: {
            solo: true,
            event: 'click',
        },
        hide: {
            fixed: true,
            delay: 0,
            event: 'unfocus',
        },
        style: {
            classes: 'qtip-input',
            tip: false
        },
        events: {
            show(e, api) {
                const $field = api.elements.target.closest('.field');
                api.elements.tooltip.css({
                    minWidth: $field.length ? $field[0].getBoundingClientRect().width : api.elements.target[0].getBoundingClientRect().width,
                });
                api.elements.target.trigger('on-show.selo');
            },
            move(e, api) {
                if ( api.position.my.y === 'top' ) {
                    api.tooltip.removeClass('qtip-pos-bottom').addClass('qtip-pos-top');
                }
                else if ( api.position.my.y === 'bottom' ) {
                    api.tooltip.removeClass('qtip-pos-top').addClass('qtip-pos-bottom');
                }
            },
            hide(e, api) {
                api.elements.target.trigger('on-hide.selo');
            },
            render(e, api) {
                api.elements.target.trigger('on-render.selo');
            },
        }
    };

    $('[js-selo]', context).each((selectIndex, select) => {
        const $select = $(select);
        if ( $select.data('selo-inited') ) return;
        const $field = $select.closest('[js-selo-field]');
        const $title = $field.find('[js-selo-title]');
        const $container = $field.find('[js-selo-container]');
        const isTitleInput = $title.is(':input');
        const isMultiple = !!$select.attr('multiple');
        const defaultValue = '';
        const settings = $.extend({
            hideDefault: true,
            count: Infinity,
            countTitle: (selected, all) => `Выбрано <span class="field-input__count">${selected}</span>`,
            optionsMod: '',
            extraOptions: [],
            notFoundTitle: 'Нет совпадений',
        }, $select.data('selo-settings'));
        const $selectController = $field.find('.field__main');
        const $optionsContainer = $(`<div js-selo-options-container class="field-options ${ settings.optionsMod.modNormalizer('field-options') }" />`);
        const $optionsList = $('<div js-scrollbar js-selo-options-list class="field-options__list" />').appendTo($optionsContainer);
        const $optionsItems = createOptionsElements($select, {defaultValue, isMultiple}).appendTo($optionsList);
        const $notFound = $(`<div js-selo-option-notfound class="field-options__item field-options__item_notfound"><div class="field-options__item-title">${ settings.notFoundTitle }</div></div>`);
        let $extraOptionsList = $();
        let $extraOptionsItems = $();
        let tipApi = null;
        let isSearching = false;
        let isOpen = false;

        const toggleValue = function (value) {
            if ( value == null ) return;
            const currentValue = $select.val();
            if ( isMultiple && currentValue ) {
                // Если есть значение в мультиселекте
                if ( currentValue.indexOf(value) > -1 ) {
                    currentValue.splice(currentValue.indexOf(value), 1);
                }
                else {
                    currentValue.push(value);
                }
                $select.val(currentValue).trigger('change');
            }
            else {
                $select.val(value).trigger('change');
            }
        };

        if ( isMultiple ) {
            settings.hideDefault = true;
        }

        if ( settings.hideDefault ) {
            $optionsContainer.addClass('field-options_hide-default');
        }

        if ( isMultiple ) {
            $optionsContainer.addClass('field-options_multiple');
        }
        else {
            $optionsContainer.addClass('field-options_single');
        }

        // Если дополниельные элементы списка
        if ( Array.isArray(settings.extraOptions) && settings.extraOptions.length ) {
            $extraOptionsList = $('<div js-selo-extra-options-list class="field-options__list field-options__list_extra" />').appendTo($optionsContainer);
            $extraOptionsItems = createExtraOptionsElements(settings.extraOptions, {defaultValue, isMultiple}).appendTo($extraOptionsList);
            $(settings.extraOptions.map((option) => `<option data-extra-option="true" value="${ option.value }">${ option.title }</option>`).join('')).appendTo($select);

            // Подключаем возможность выбора для экстра элементов
            $extraOptionsItems.off('.selo').on({
                'click.input-helper select.input-helper': (e) => {
                    toggleValue(e.currentTarget.dataset.value);
                    $select.trigger('hide.selo');
                },
            });
        }

        // Активируем скрол
        app.use('scrollbar', $optionsContainer);

        // Подключаем возможность выбора для элементов списка
        $optionsItems.off('.selo').on({
            'click.input-helper select.input-helper': (e) => {
                toggleValue(e.currentTarget.dataset.value);
            },
        });

        // Если заголовок — инпут, то подключаем поиск
        if ( isTitleInput ) {
            let titleValueWas = '';
            let selectValue = $select.val();

            $notFound.appendTo($optionsList);

            $title.off('.selo').on({
                'focus.input-helper': (e) => {
                    titleValueWas = $title.val();
                },
                'blur.input-helper': (e) => {},
                'input.input-helper': (e) => {
                    if ( !isSearching && $title.val() !== titleValueWas ) {
                        isSearching = true;
                    }
                    if ( isSearching ) {
                        const $foundItems = filterOptionsElementsByValue($optionsItems, $title.val(), {hideDefault: settings.hideDefault});
                        $notFound.toggleClass('is-visible', $foundItems.length === 0 );
                    }
                },
                'keyup.input-helper': (e) => {
                    switch (e.keyCode) {
                        case 13: // Enter
                            if ( $title.val().length ) {
                                filterOptionsElementsByValue($optionsItems, $title.val(), {hideDefault: settings.hideDefault}).eq(0).trigger('select.input-helper');
                                $title.trigger('blur');
                            }
                            break;
                    }
                },
                'cancel-search.input-helper': (e, payload = {reset: false}) => {
                    if ( !isSearching ) return;
                    $notFound.removeClass('is-visible');
                    if ( isMultiple ) {
                        $title.val(null).trigger('change');
                    }
                    else {
                        $title.val(titleValueWas).trigger('change');
                    }
                    setTimeout(() => {
                        filterOptionsElementsByValue($optionsItems, null);
                    }, 100)
                    isSearching = false;
                },
            });
        }

        $select.off('.selo').on({
            'set-value.selo': (e, payload = {}) => {
                const newValue = payload.value;
                if ( newValue === undefined ) return;
                if ( isSearching && !isMultiple ) {
                    $title.trigger('cancel-search.input-helper');
                }
                const $items = $optionsItems.add($extraOptionsItems);
                const selectedInfo = getSelectedInfo($items, newValue, {count: settings.count, countTitle: settings.countTitle});
                selectItemsByValue($items, newValue);
                if ( isTitleInput && !isMultiple ) {
                    $title.val(selectedInfo.title).trigger('change');
                }
                else if ( !isTitleInput ) {
                    if ( newValue === defaultValue || newValue == null ) {
                        $title.html($title.attr('placeholder'));
                    }
                    else {
                        $title.html(selectedInfo.title);
                    }
                }

                if ( isMultiple && tipApi ) {
                    tipApi.reposition();
                }
                else {
                    $select.trigger('hide.selo');
                }

                if ( isTitleInput && isOpen ) {
                    $title.trigger('focus');
                }
            },
            'unselect.selo': (e, payload = {value: null}) => {
                toggleValue(payload.value);
            },
            'change.selo changeSilent.selo': (e) => {
                $select.trigger('set-value', {value: $select.val()});
            },
            'hide.selo': (e) => {
                if ( tipApi ) {
                    tipApi.hide();
                }
            },
        }).trigger('set-value', {value: $select.val()});

        $container.off('.selo').on({
            'on-show.selo': (e) => {
                isOpen = true;
                $field.addClass('is-selo-opened');
            },
            'on-hide.selo': (e) => {
                isOpen = false;
                $title.trigger('cancel-search.input-helper');
                $field.removeClass('is-selo-opened');
            },
            'on-render.selo': (e) => {},
        });

        tipApi = $container.qtip($.extend(true, {}, tipOptions, {
            content: {
                text: $optionsContainer,
            },
            style: {
                classes: tipOptions.style.classes + ' ' + settings.mod
            }
        },$container.data('qtip-options') )).qtip('api');

        $select.data('selo-inited', true);
    });

    function getSelectedInfo ($items, value, options = {}) {
        options.count = options.count !== null ? options.count : 0;
        options.countTitle = typeof options.countTitle === 'function' ? options.countTitle : (selected, all) => `${selected} из ${all}`;
        let title = '';
        let $selectedItems = $();

        if ( Array.isArray(value) ) {
            $selectedItems = $items.filter((itemIndex, item) => value.indexOf(item.dataset.value) > -1);
            value = value.map((item) => item.toString());
            if ( $selectedItems.length > options.count ) {
                title = options.countTitle($selectedItems.length, $items.length);
            }
            else {
                title = $selectedItems.toArray().map((item) => item.dataset.title).join(', ');
            }
        }
        else if ( value ) {
            $selectedItems = $items.filter((itemIndex, item) => item.dataset.value === value);
            value = value.toString();
            title = $selectedItems.data('title');
        }

        return {
            selectedCount: $selectedItems.length,
            allCount: $items.length,
            title,
        };
    }

    function filterOptionsElementsByValue ($items, value, options = {hideDefault: false}) {
        if ( !value ) return $items.show();
        let $matching = $items.filter((itemIndex, item) => item.dataset.title.toLowerCase().indexOf(value.toLowerCase()) > -1);

        if ( options.hideDefault ) {
            $matching = $matching.not('.is-default');
        }

        $items.not($matching.css('display', '')).hide();
        return $matching;
    }

    function createExtraOptionsElements (extraOptions = [], options = {defaultValue: '', isMultiple: false}) {
        return $(extraOptions.map((item) => {
            return `
                <div js-selo-option class="field-options__item field-options__item_extra ${item.value === options.defaultValue ? 'is-default' : ''}" data-value="${ item.value }" data-title="${ item.title }">
                    <div class="field-options__item-title">${ item.title }</div>
                </div>
            `.trim();
        }).join(''));
    }

    function createOptionsElements ($select, options = {defaultValue: '', isMultiple: false}) {
        return $($select.children().not('[data-extra-option]').toArray().map((item) => {
            return `
                <div js-selo-option class="field-options__item ${item.value === options.defaultValue ? 'is-default' : ''}" data-value="${ item.value }" data-title="${ item.innerHTML }">
                    ${ options.isMultiple ? `
                        <div class="field-options__item-indicator"></div>
                    ` : '' }
                    <div class="field-options__item-title">${ item.innerHTML }</div>
                </div>
            `.trim();
        }).join(''));
    }

    function selectItemsByValue($items, value) {
        $items.filter('.is-selected').removeClass('is-selected');

        if ( Array.isArray(value) ) {
            value = value.map((item) => item.toString());
            $items.filter((itemIndex, item) => value.indexOf(item.dataset.value) > -1).addClass('is-selected');
        }
        else if ( value ) {
            value = value.toString();
            $items.filter((itemIndex, item) => item.dataset.value == value).addClass('is-selected');
        }
        else {
            $items.filter('.is-default').addClass('is-selected');
        }
    };
});

app.bind('default decimal inputs basic', context => {
    $('[js-input-decimal]', context).attr('data-is-inputmask', true).each((inputIndex, input) => {
        const $input = $(input);

        let { minValue, maxValue } = getMinMax($input);
        let value = parseInt($input.val().replace(/[^0-9.]/g, ''));

        $input.off('.input-number').on({
            'input.input-number': (e) => {
                setValue();
            },
        }).inputmask("decimal", {
            rightAlign: false,
            digits: 2,
            autoGroup: true,
            groupSeparator: " ",
            allowPlus: false,
            allowMinus: false,
            autoUnmask: true,
        });

        function setValue (val = parseInt($input.val().replace(/[^0-9.]/g, ''))) {
            if ( val < minValue ) {
                value = minValue;
                $input.val(value).trigger('change');
            }
            else if ( val > maxValue ) {
                value = maxValue;
                $input.val(value).trigger('change');
            }
            else {
                value = val;
            }

            return value;
        }

        function getMinMax($input) {
            let minValue = typeof $input.data('min') !== 'undefined' ? parseInt($input.data('min')) : $input.prop('min').length > 0 ? $input.prop('min') : 1;
            let maxValue = typeof $input.data('max') !== 'undefined' ? parseInt($input.data('max')) : $input.prop('max').length > 0 ? $input.prop('max') : 999999999;

            return { minValue, maxValue };
        }
    });
});

app.bind('default range inputs basic', context => {
    $('[js-input-range]', context).each((index, item) => {
        const $item = $(item);
        const $rangeBox = $('<span class="field-range__line"><input js-input-range type="text" value="" /></span>');
        const $inputs = $item.find('input');

        const type = $inputs.length > 1 ? 'double' : 'single';
        const options = $item.data('options');
        const { minValue, maxValue } = getMinMax($inputs);


        const inputRangeApi = $item.prepend($rangeBox).find('[js-input-range]').ionRangeSlider({
            type,
            step: options.step,
            min: minValue,
            max: maxValue,
            extra_classes: 'field-range-line',
            onStart(data) {
                setInputValue(data);
            },
            onChange(data) {
                setInputValue(data);
            }
        }).data('ionRangeSlider');

        $inputs.off('.input-range-update').on('input.input-range-update', event => {
            const $item = $(event.currentTarget);
            const type = $item.data('range-type');
            let value = $item.val();

            if (value < minValue) {
                value = minValue;
            } else if (value > maxValue) {
                value = maxValue;
            }

            inputRangeApi.update({ [type === 'min' ? 'from': 'to']: value });
        });

        function setInputValue({ from, to }) {
            if (type === 'double') {
                $inputs.filter('[data-range-type="min"]').val(from).trigger('change');
                $inputs.filter('[data-range-type="max"]').val(to).trigger('change');
            }
            else if (type === 'single') {
                $inputs.val(from).trigger('change');
            }
        }

        function getMinMax($input) {
            let minValue = typeof $input.data('min') !== 'undefined' ? parseInt($input.data('min')) : $input.prop('min').length > 0 ? $input.prop('min') : 1;
            let maxValue = typeof $input.data('max') !== 'undefined' ? parseInt($input.data('max')) : $input.prop('max').length > 0 ? $input.prop('max') : 999999999;

            return { minValue, maxValue };
        }
    });
});

app.bind('default cloning basic', context => {
    const $addControllers = $('[js-clone-add]', context);

    $addControllers.each((index, item) => {
        const $addController = $(item);
        const $lists = $addController.closest('[js-clone-list]');
        const $items = $addController.closest('[js-clone-item]');

        const $item = filterElementsById($items, $addController.data('id'));
        const clonedItemZero = $item.clone();
        clonedItemZero.addClass('is-cloned');

        $addController.off('.clone').on({
            'click.clone': (e) => {
                e.preventDefault();
                const $currentController = $(e.currentTarget);
                const $list = filterElementsById($lists, $currentController.data('id'));
                let clonedItem = clonedItemZero.clone();

                $list.append(clonedItem);
                app.use('basic', clonedItem);

                const $removeController = clonedItem.find('[js-clone-remove]');
                $removeController.off('.clone').on({
                    'click.clone': (e) => {
                        e.preventDefault();
                        clonedItem.remove();
                    },
                });
            },
        });

    });

    function filterElementsById($elements, id) {
        if ( !$elements.length ) return $();
        return $elements.filter((elementIndex, element) => $elements.eq(elementIndex).data('id') == id);
    }
});
